const ISO_WALL_CLOCK_RE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/;

export const formatCameraDate = (isoString) => {
  if (!isoString) return '—';

  const match = ISO_WALL_CLOCK_RE.exec(isoString);
  if (!match) return '—';

  const [, year, month, day, hour, minute] = match;
  return `${day}.${month}.${year} ${hour}:${minute}`;
};
